(ns vit-configurator.auth
  (:require
   ["@auth0/auth0-spa-js" :as auth0 :refer (Auth0Client)]
   [shadow.cljs.modern :refer (js-await)]
   [re-frame.core :as re-frame])
  (:require-macros [vit-configurator.config :refer [required-env-var optional-env-var]]))


;; set auth requirement
; only skip auth if env var is "false"
(def auth-required? (not= "false" (optional-env-var :auth-required)))

;; get variables for config
(defn window-location [] (str (.. js/window -location -origin)))
(def current-window-location (window-location))
(def redirect-uri (str current-window-location))
(def client-id
  (when auth-required?
    (required-env-var :auth0-client-id)))
(def domain
  (when auth-required?
    (required-env-var :auth0-domain)))

(def auth0-config (clj->js {:domain domain
                            :clientId client-id
                            :useRefreshTokens true
                            :cacheLocation "localstorage"
                            :authorizationParams {:redirect_uri redirect-uri}}))

(defn get-query-params []
  (-> (.. js/window -location)
      js/URL.
      .-searchParams
      js/Object.fromEntries
      (js->clj :keywordize-keys true)))

(defn contains-many? [m & ks]
  "Returns true if m contains each key in ks"
  (every? #(contains? m %) ks))

(defn redirect-callback?
  "Auth0 redirects after logging in with URL parameters 'state' and 'code',
   which must be processed to log in. This function checks if the page has
   the necessary parameters to handle an auth0 redirect."
  []
  (contains-many? (get-query-params) :state :code))

(defn update-window-history
  "Removes query parameters from URL and sets window history to /"
  []
  (.replaceState js/window.history #js {} js/document.title "/"))

(defn auth0-get-client
  "Creates auth0 client with js config"
  [config]
  (try
    (Auth0Client. config)
    (catch :default e
      (js/console.error "Can't construct Auth0 client: %o" e))))

; do not initialize auth0 client if auth not required
(when auth-required?
  (defonce ^js auth0-client (auth0-get-client auth0-config)))

; Everything below requires a defined auth0 client

(defn auth0-login []
  (js-await [login (.loginWithRedirect auth0-client)]))

(re-frame/reg-event-db
 ::set-authenticated?
 (fn [db [_ authenticated?]]
   (assoc db :authenticated? authenticated? :auth-loading? false)))

(defn auth0-is-authenticated
  "Gets authentication from auth0 client and saves in db"
  []
  (js-await [authenticated? (.isAuthenticated auth0-client)]
    (re-frame/dispatch [::set-authenticated? authenticated?])
    (catch e
      (js/console.error e)
      (re-frame/dispatch [::set-authenticated? false]))))

(re-frame/reg-fx ::auth0-is-authenticated auth0-is-authenticated)

(re-frame/reg-event-db
 ::set-user
 (fn [db [_ user]]
   (assoc db :user user :user-loading? false)))

(defn auth0-get-user
  "Gets user from auth0 client and saves in db"
  []
  (js-await [user-js (.getUser auth0-client)]
    (let [user (js->clj user-js :keywordize-keys true)]
      (re-frame/dispatch [::set-user user]))
    (catch e
      (js/console.error e)
      (re-frame/dispatch [::set-user nil]))))

(re-frame/reg-fx ::auth0-get-user auth0-get-user)

(re-frame/reg-event-fx
 ::initialize
 (fn [{:keys [db]} _]
   {:db (assoc db :user-loading? true :auth-loading? true)
    ::auth0-is-authenticated nil
    ::auth0-get-user nil}))

(defn auth0-handle-redirect-callback
  "Calls auth0 redirect callback handler and updates authentication and user"
  []
  (js-await [callback (.handleRedirectCallback auth0-client)]
    (re-frame/dispatch [::initialize])
    (update-window-history)
    (catch e (js/console.error e))))

(re-frame/reg-fx ::auth0-handle-redirect-callback auth0-handle-redirect-callback)

(re-frame/reg-event-fx
 ::redirect-callback
 (fn [{:keys [db]} _]
   {::auth0-handle-redirect-callback nil}))

(re-frame/reg-fx
 ::auth0-logout
 (fn []
   (.logout
    auth0-client
    (clj->js {:logoutParams {:returnTo current-window-location}}))))

(re-frame/reg-event-fx
 ::logout
 (fn [{:keys [db]} _]
   {:db (assoc db :authenticated? false :user nil)
    ::auth0-logout nil}))
